import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { clearStorage, dirty, logoutRequest } from "../../store/session/actions";
import { useAuth0 } from "@auth0/auth0-react";
import Auth0Login from "../../pages/login/Auth0Login";
import { ActiveProvider } from "../../lib/utils";
import useSession from "../../effects/useSession";
import {fetchRequest} from "../../store/user/actions"

interface Props {
  name?: string;
  id?: string | null;
  email?: string | null;
}

function ProfileMenu({ id }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { logout } = useAuth0();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const session: any = useSession();
  // console.log('session',session);
  const handleLogout = async () => {
    try {
      // Use the session logout saga to handle backend logout and token blacklisting
      dispatch(logoutRequest((error: string | null, success: boolean) => {
        if (success) {
          console.log('✅ Token successfully blacklisted via session saga');
        } else {
          console.warn('⚠️ Failed to blacklist token, but continuing with logout');
        }
        
        // Clear session and storage
        dispatch(dirty());
        dispatch(clearStorage());
        
        // Perform Auth0 logout
        const logoutParams = { logoutParams: { returnTo: window.location.origin } };
        console.log("Do AUTH0 logout ", logoutParams);
        logout(logoutParams);
      }));
      
    } catch (error) {
      console.error('❌ Error during logout:', error);
      
      // Continue with logout even if blacklisting fails
      dispatch(dirty());
      dispatch(clearStorage());
      sessionStorage.removeItem('access_token');
      
      const logoutParams = { logoutParams: { returnTo: window.location.origin } };
      logout(logoutParams);
    }
  };

  const handleMyAccountClick = () => {
    dispatch(fetchRequest(id))
    history.push(`/user/edit/${id}`);
  };

  return (
    <div id="profile-menu">
      <IconButton color="inherit" onClick={handleClick}>
        <PersonOutlineIcon />
      </IconButton>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleMyAccountClick}>My account</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
}

export default ProfileMenu;
